import { Injectable } from '@angular/core';
import { ApiGatewayService } from '../services/api-gateway.service';
import { ServiceObject } from 'src/app/model/service-object';
import { AppEnviroment } from 'src/app/model/app-enviroment';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {ChangeStateRequest} from '../../model/change-state-request';
import {User} from '../../model/user';
import {ApplicationBase} from '../../model/application-base';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationBusinessService {

  constructor(private apigateway: ApiGatewayService, private router: Router, private translate: TranslateService ) {

   }

  public async CreateSession(login: string, password: string, captchaInput: string, captchaId: string ) {
    return this.apigateway.CreateSession(login, password, captchaInput, captchaId)
      .then(x => {
        const serviceResponse = x as ServiceObject;
        if (!serviceResponse.Success) {
          throw new Error(serviceResponse.Message);
        }
        // Guarda Usuario en Session
        serviceResponse.Data.SessionToken = serviceResponse.SessionToken;
        AppEnviroment.User = serviceResponse.Data;

        // Mapea objeto
        return Promise.resolve(serviceResponse.User);
      })
      .catch(x => {
        throw x;
      });
  }

  public CloseSession() {
    AppEnviroment.CloseSession();
    this.router.navigate(['/auth/signin']);
  }

  public ValidateSession(): boolean {
    if (AppEnviroment.User == null) {
        this.CloseSession();
        return false;
      }
    return true;
  }

  public GetPathRestorePassword(): Promise<string> {
    // return Promise.resolve("https://www.google.com");
    return this.apigateway.GetPathRestorePassword()
      .then(x => {
        const serviceResponse = x as ServiceObject;
        if (!serviceResponse.Success) {
          throw new Error(serviceResponse.Message);
        }
        // Mapea objeto
        return Promise.resolve(serviceResponse.Data);
      })
      .catch(x => {
        throw x;
      });
  }

  public async RememberPassword(mail: string): Promise<string> {
    return this.apigateway.RememberPassword(mail)
      .then(x => {
        const serviceResponse = x as ServiceObject;
        if (!serviceResponse.Success) {
          throw new Error(serviceResponse.Message);
        }

        // Mapea objeto
        return Promise.resolve(serviceResponse.Message);
      })
      .catch(x => {
        throw x;
      });
  }

  public ValidateCodeRestore(code: string): Promise<User> {
    return this.apigateway.ValidateCodeRestore(code)
      .then(x => {
        const serviceResponse = x as ServiceObject;
        if (!serviceResponse.Success) {
          throw new Error(serviceResponse.Message);
        }

        // Mapea objeto
        return Promise.resolve(serviceResponse.Data);
      })
      .catch(x => {
        throw x;
      });
  }

  ChangePassword(login: string, password: string): Promise<User> {
    return this.apigateway.ChangePassword(login, password)
      .then(x => {
        const serviceResponse = x as ServiceObject;
        if (!serviceResponse.Success) {
          throw serviceResponse.Message;
        }
        serviceResponse.Data.SessionToken = serviceResponse.SessionToken;
        AppEnviroment.User = serviceResponse.Data;
        // Mapea objeto
        return Promise.resolve(serviceResponse.Data);
      })
      .catch(x => {
        throw x;
      });

  }

  public GetUser() {
    // Define idioma por defecto usuario
    this.ValidateSession();
    return AppEnviroment.User;
  }

  public GetApiEndPoint() {
    return AppEnviroment.ApiEndPoint;
  }


}
